import { render, staticRenderFns } from "./ArtLinkCreate.vue?vue&type=template&id=5461d9fe&scoped=true&"
import script from "./ArtLinkCreate.vue?vue&type=script&lang=js&"
export * from "./ArtLinkCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5461d9fe",
  null
  
)

export default component.exports